import React from 'react'
import { useIntl } from 'react-intl'

import LuxuryEscapesSmallLogo from 'components/App/Header/Logo/logos/LuxuryEscapesSmallLogo'
import Caption from 'LuxKit/Typography/Caption'
import Group from 'components/utils/Group'

function LEBookingTag() {
  const intl = useIntl()

  return (
    <Group
      gap={8}
      tabletGap={4}
      direction="horizontal"
      horizontalAlign="start"
      verticalAlign="center"
    >
      <LuxuryEscapesSmallLogo width={16} />
      <Caption variant="large" weight="bold">
        {intl.formatMessage({
          id: 'daqaa16EuNyjb0RSsn6I',
          defaultMessage: 'Luxury Escapes Booking',
          description: 'Label indicating a trip item was booked through Luxury Escapes',
        })}
      </Caption>
    </Group>
  )
}

export default React.memo(LEBookingTag)
